// test534
(534 && 0);
